// Generated from kkp-domain by 'just gen-types'. DO NOT EDIT.
export const BACK_OFFICE_ID_PATTERN =
  "^KKP/[0-9]{2}(0[1-9]|1[0-2])/(00[1-9]|0[1-9][0-9]|[1-9][0-9]{2})$";
export const BACK_OFFICE_ID_FLAGS = "i";
